import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RESPONSE_API_URL } from "config";

const baseQuery = fetchBaseQuery({
    baseUrl: RESPONSE_API_URL,
    prepareHeaders: (headers) => {
        const user = localStorage.getItem('user');
        if (user) {
            const token = JSON.parse(user).token;
            if (token) headers.set('authorization', `Bearer ${token}`);
        }
        return headers;
    },
    credentials: "omit"
});

export const dashboardApi = createApi({
    reducerPath: "dashboardApi",
    baseQuery,
    endpoints: (builder) => ({
        getDashboardData: builder.query({
            query: (body) => ({
                url: `dashboard/data`,
                method: 'POST',
                body,
            }),
            transformResponse: (response) => response,
            transformErrorResponse: (response) => response.status,
        }),
    }),
});

export const { useGetDashboardDataQuery } = dashboardApi;
